import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 60000,
});

export function formatApiErrorDetail(detail, isNetworkError = false) {
  if (detail == null)
    return isNetworkError
      ? "No se pudo conectar con el servidor. Espere unos segundos e intente de nuevo."
      : "Ocurrió un error. Intente de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const MOVEMENT_LABELS = {
  lleno_entrando: "Lleno Entrando",
  vacio_entrando: "Vacío Entrando",
  lleno_saliendo: "Lleno Saliendo",
  vacio_saliendo: "Vacío Saliendo",
};

export const MOVEMENT_COLORS = {
  lleno_entrando: "bg-emerald-100 text-emerald-800 border-emerald-300",
  vacio_entrando: "bg-sky-100 text-sky-800 border-sky-300",
  lleno_saliendo: "bg-amber-100 text-amber-800 border-amber-300",
  vacio_saliendo: "bg-violet-100 text-violet-800 border-violet-300",
};

export const SIZES = ["20 pies", "40 pies", "40 pies High Cube", "45 pies", "53 pies"];
export const CONDITIONS = ["Bueno", "Daño leve", "Daño severo", "En mantenimiento"];

export const TRANSIT_LABELS = {
  en_origen: "En Origen",
  en_transito: "En Tránsito",
  en_escala: "En Puerto de Escala",
  llegado_panama: "Llegó a Panamá",
};

export const TRANSIT_COLORS = {
  en_origen: "bg-slate-100 text-slate-700 border-slate-300",
  en_transito: "bg-sky-100 text-sky-800 border-sky-300",
  en_escala: "bg-amber-100 text-amber-800 border-amber-300",
  llegado_panama: "bg-emerald-100 text-emerald-800 border-emerald-300",
};

export function fmtDate(value) {
  if (!value) return "-";
  const d = new Date(String(value).length === 10 ? `${value}T12:00:00` : value);
  if (isNaN(d)) return "-";
  return d.toLocaleDateString("es-PA", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "America/Panama" });
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function fmtDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d)) return "-";
  return d.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "America/Panama" });
}

export function locationLabel(m) {
  if (m.fuera_de_rampa) return "Fuera de rampa";
  return m.ramp_number ? `Rampa #${m.ramp_number}` : "Sin rampa asignada";
}
